import React from 'react';
import { graphql, Link } from 'gatsby';
import { Product } from '../../pages/products';
import ProductCard from '../ProductCard';
import clsx from 'clsx';
import { CommonSectionProps, SectionBgColor } from '../../templates/Page';
import { areSameFlatColor } from '../../utils/utils';

import * as styles from './ProductsListSection.module.scss';

export const ProductsListSectionFragment = graphql`
  fragment ProductsListSection on SanityProductsListSection {
    title
    products {
      ...Product
    }
  }
`;

export type ProductsListSectionProps = {
  title: string;
  products: Array<Product>;
  className?: string;
};

export function getSectionBgColor(props: ProductsListSectionProps): SectionBgColor<'white'> {
  return {
    name: 'white',
    type: 'solid',
  };
}
function ProductsListSection<PrevSectionColorName extends string>(
  props: ProductsListSectionProps & CommonSectionProps<PrevSectionColorName>,
): React.ReactElement {
  const { title, products, className, previousSectionBgColor } = props;

  const listedProducts = products.filter(product => !product.unlisted);

  return (
    <section
      id={props.sectionID || ''}
      className={clsx(
        styles.sectionContainer,
        className,
        areSameFlatColor(getSectionBgColor(props), previousSectionBgColor) && styles.noPaddingTop,
      )}
    >
      <div className={styles.section}>
        <h2 className={styles.title}>{title}</h2>
        <div className={styles.productsContainer}>
          {listedProducts.map(product => (
            <Link
              key={product._id}
              className={clsx(styles.cardLinkWrapper)}
              to={`/products/${product.slug.current}`}
            >
              <ProductCard product={product}></ProductCard>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ProductsListSection;
